import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import actions from '@flux/action';

import PropTypes from 'prop-types';

function ExpandBtn({
  onClick,
  initialExpand = false,
  mainPageDropDownHandler,
  scrollPageFooter,
}) {
  const [expand, toggleExpand] = useState(initialExpand);

  useEffect(() => {
    if (expand) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [expand]);

  const handleClick = (e) => {
    mainPageDropDownHandler(false);
    toggleExpand((state) => !state);

    onClick && onClick(e);
    const pageFooter = document.querySelector('.app-footer');
    if (pageFooter && scrollPageFooter) {
      pageFooter.scrollIntoView({ block: 'start' });
    }
  };
  return (
    <button
      type="button"
      aria-label="Floating button"
      className="full-screen-button-bg"
      onClick={handleClick}
    >
      <span
        className={`appkiticon a-btn-icon ${
          expand ? 'icon-minimize-fill' : 'icon-expand-fill'
        }`}
      />
    </button>
  );
}

ExpandBtn.defaultProps = {
  onClick: null,
};

ExpandBtn.propTypes = { onClick: PropTypes.func };

const mapDispatchToPpops = (dispatch) => ({
  mainPageDropDownHandler(bool) {
    dispatch(actions.mainPageDropDownHandler(bool));
  },
});
export default connect(null, mapDispatchToPpops)(ExpandBtn);
